import { useState } from "react";
import { X } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
const slides = [
  "/images/haji/hj-edu01.JPG",
  "/images/haji/hj-edu02.JPG",
  "/images/haji/hj-edu03.JPG",
  "/images/haji/hj-edu04.JPG",
  "/images/haji/hj-edu05.JPG",
  "/images/haji/hj-edu06.JPG",
  "/images/haji/hj-edu07.JPG",
  "/images/haji/hj-edu08.JPG",
];
const faqs = [
  {
    q: "Apa itu Haji Khusus?",
    a: "Haji Khusus adalah program ibadah haji yang diselenggarakan oleh PIHK resmi dengan fasilitas dan layanan yang lebih premium dibanding haji reguler."
  },
  {
    q: "Apa perbedaan Haji Reguler dan Haji Khusus?",
    a: "Haji Khusus menawarkan layanan yang lebih nyaman, pendampingan yang lebih intensif, dan masa tunggu yang umumnya lebih singkat sesuai kuota yang tersedia."
  },
  {
    q: "Apakah Baba Tour memiliki izin resmi?",
    a: "Baba Tour melayani program Haji Khusus melalui mitra resmi dan sesuai dengan ketentuan yang berlaku dari Kementerian Agama RI."
  },
  {
    q: "Apa saja fasilitas yang didapatkan?",
    a: "Fasilitas meliputi akomodasi hotel, transportasi, konsumsi, manasik, pembimbing ibadah, dan layanan pendukung lainnya sesuai paket."
  },
  {
    q: "Bagaimana cara mendaftar?",
    a: "Silakan konsultasikan kebutuhan Anda melalui WhatsApp dan tim kami akan membantu proses pendaftaran hingga keberangkatan."
  }
];
export default function HajiKhusus() {
const [current, setCurrent] = useState(0);
const [openWA, setOpenWA] = useState(false);
const [openFaq, setOpenFaq] = useState(null);
  const msg = encodeURIComponent(
    "Assalamualaikum Baba Tour, saya ingin informasi Haji Khusus."
);
  return (
    <div className="bg-[color:var(--bg)] min-h-screen">
      <Header />
{openWA && (
  <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
    <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-lg">
          Pilih Kantor
        </h3>

        <button onClick={() => setOpenWA(false)}>
          <X className="w-5 h-5" />
        </button>
      </div>

      <a
        href={`https://wa.me/6282392156538?text=${msg}`}
        target="_blank"
        rel="noreferrer"
        className="block w-full bg-green-500 text-white text-center rounded-xl py-3 mb-3"
      >
        📍 Batam
      </a>

      <a
        href={`https://wa.me/62811713309?text=${msg}`}
        target="_blank"
        rel="noreferrer"
        className="block w-full bg-green-500 text-white text-center rounded-xl py-3"
      >
        📍 Palembang
      </a>
    </div>
  </div>
)}
<section className="pt-28 lg:min-h-[85vh] flex items-center">
<div className="max-w-4xl mx-auto px-6">
          <div className="text-sm uppercase tracking-[0.22em] text-accent font-semibold">
            Program Haji Khusus
          </div>

          <h1 className="font-serif-display text-primary text-5xl mt-4">
            Haji Khusus Baba Tour
          </h1>

          <p className="text-muted mt-6 text-lg leading-relaxed">
            Program Haji Khusus dengan pendampingan profesional,
            fasilitas premium, dan pelayanan terbaik untuk menunjang
            kenyamanan ibadah Anda di Tanah Suci.
          </p>
<div className="mt-8">
  <div className="overflow-hidden rounded-3xl shadow-lg">
    <img
      src={slides[current]}
      alt={`Slide ${current + 1}`}
className="w-full lg:max-h-[420px] object-contain"
    />
  </div>

<div className="flex justify-center gap-4 mt-3">
    <button
      onClick={() =>
        setCurrent(current === 0 ? slides.length - 1 : current - 1)
      }
      className="px-5 py-2 border rounded-full"
    >
      ← Sebelumnya
    </button>

    <button
      onClick={() =>
        setCurrent(current === slides.length - 1 ? 0 : current + 1)
      }
      className="px-5 py-2 border rounded-full"
    >
      Berikutnya →
    </button>
  </div>
</div>
        </div>
      </section>
<section className="py-20">
  <div className="max-w-4xl mx-auto px-6">

    <h2 className="text-3xl font-bold text-center mb-10">
      Pertanyaan yang Sering Diajukan
    </h2>

    <div className="space-y-4">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="border rounded-2xl overflow-hidden"
        >
          <button
            onClick={() =>
              setOpenFaq(openFaq === index ? null : index)
            }
            className="w-full flex justify-between items-center p-5 text-left font-medium"
          >
            <span>{faq.q}</span>

            <span className="text-2xl">
              {openFaq === index ? "−" : "+"}
            </span>
          </button>

          {openFaq === index && (
            <div className="px-5 pb-5 text-muted">
              {faq.a}
            </div>
          )}
        </div>
      ))}
    </div>

  </div>
</section>
<section className="py-20">
  <div className="max-w-4xl mx-auto px-6 text-center">

    <h2 className="text-4xl font-bold text-primary mb-4">
      Siap Merencanakan Haji Anda?
    </h2>

    <p className="text-muted mb-8">
      Konsultasikan kebutuhan Haji Khusus Anda bersama tim Baba Tour.
    </p>

    <button
      onClick={() => setOpenWA(true)}
      className="bg-primary text-white px-8 py-4 rounded-full"
    >
      Konsultasi Haji Khusus
    </button>

  </div>
</section>
      <Footer />
    </div>
  );
}
